/** The window asks the local daemon to publish with this Mac's Mod sign-in. */
import type { AppSummary, Published } from '@mod/core/model'
import { localServer } from '../../sdk/localServer'

async function post<T>(path: string, body: unknown): Promise<T> {
  const response = await fetch(`${localServer()}${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  })
  const result = (await response.json().catch(() => ({}))) as T & {
    error?: string
  }
  if (!response.ok)
    throw new Error(result.error ?? `Local server returned ${response.status}`)
  return result
}

export function publishInstalled(
  app: AppSummary,
  catalogId: string,
  page: { category: string; about: string; screenshots: string[] },
  /** Absent leaves the app's default: source for an app written in a chat. */
  includeSource?: boolean,
): Promise<Published> {
  return post('/apps/publish', {
    appId: app.id,
    catalogId,
    page,
    ...(includeSource !== undefined ? { includeSource } : {}),
  })
}

export async function uploadScreenshot(png: string): Promise<string> {
  const result = await post<{ url: string }>('/apps/screenshot', { png })
  return result.url
}
